export const _initialState = {
  collection: {
    choices: null,
    options: null,
    choiceMetadata: null,
    searchModelSKus: null,
    choiceBasedProducts: null,
    searchProducts: null,
  },
  isSkusFetched: false,
  fetchedItemIdsByChoice: {}, // Store fetchedItemIds per choice
  fetchedCategories: [],
};